import { useEffect, useRef, useState } from 'react';
import { IVideoProcessingQueueItemProps } from '../../../../services/SportVideoQueue/types';

// A fila agora é lida direto do Postgres (fonte única, atualizada pelo sports-api a cada etapa),
// não mais do estado em memória do sports-api — então não deveria mais "piscar" entre polls. Mantém
// essa pequena tolerância mesmo assim como rede de segurança contra qualquer soluço passageiro de
// rede/poll, sem custo real já que os dados agora são consistentes entre polls.
const GRACE_MS = 12000;
const RECONCILE_TICK_MS = 2000;

interface TrackedItem {
  item: IVideoProcessingQueueItemProps;
  lastSeenAt: number;
}

export const useStableActiveItems = (
  latestItems: IVideoProcessingQueueItemProps[],
): IVideoProcessingQueueItemProps[] => {
  const mapRef = useRef<Map<number, TrackedItem>>(new Map());
  const [, forceRender] = useState(0);

  useEffect(() => {
    const now = Date.now();
    for (const item of latestItems) {
      mapRef.current.set(item.id, { item, lastSeenAt: now });
    }
    forceRender((n) => n + 1);
  }, [latestItems]);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      let changed = false;
      Array.from(mapRef.current.entries()).forEach(([id, tracked]) => {
        if (now - tracked.lastSeenAt > GRACE_MS) {
          mapRef.current.delete(id);
          changed = true;
        }
      });
      if (changed) forceRender((n) => n + 1);
    }, RECONCILE_TICK_MS);
    return () => clearInterval(interval);
  }, []);

  return Array.from(mapRef.current.values())
    .map((t) => t.item)
    .sort((a, b) => new Date(b.enqueuedAt).getTime() - new Date(a.enqueuedAt).getTime());
};
